export class CustomerFilter {
    public CustomerNumber?: string;
    public CustomerNameOrNumberLike?: string;
    public CustomerNumberLike?: string;
    public CustomerNameLike?: string;
    public CustomerNumbers?: string[];
    public ZQCustomerNameOrNumberLike?: string;
    public ZQCustomerNumber?: string;
    public PYPayerNumber?: string;
    public IncludeZQCustomerRecordsOnly?: boolean;
    public SalesOfficeID?: number;
    public SalesOfficeIDs?: number[];
    public DistributionChannels?: string[];
    public AccountGroup?: string;
    public AccountGroupNotEqual?: string;
    public PYPayerNumberEqualsCustomerNumber?: boolean;
    public Take?: number;
}

export default CustomerFilter;